<div class="lottie-wrapper">
    <ng-lottie [options]="options" width="400px" height="400px" />
</div>